import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { get_token } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';


export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.get_membership_types();
        this.get_billing_cycle_choices();
        this.fetch_memberships();

        $('#create_membership').on('hidden.bs.modal', () => {
            this.resetForm();
            this.errors = {};
        });
    },

    data() {
        return ({
            memberships: [],
            editing_membership_id: null,
            membership_description: '',
            membership_price: 0,
            membership_type: '',
            membership_perks: [],
            removed_membership_perks_id: [],
            billing_cycle: '',
            billing_cycle_choices: [],
            selected_membership_id: '',
            selected_manage_membership: null,
            membership_types: [],
            errors: {},
            isSubmitting: false,
            isLoading: true,
            token_exists: false,
            show_membership_type_dropdown: false,
            new_perk_name: '',
            total_paid_users:{}
        });
    },


    methods: {
        getToken() {
            return get_token();
        },
        toggleSidebar() {
            this.$refs.sidebar.$el.classList.toggle("close");
        },

        get_membership_types() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_membership_types/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.membership_types = response.data.membership_type;
                },
            });
        },

        get_billing_cycle_choices() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_billing_cycles/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.billing_cycle_choices = response.data.billing_cycles;
                },
            });

        },
        get_filtered_membership_types(query) {
            if (!query) return this.membership_types;

            const normalized_query = String(query).toLowerCase().trim();
            return this.membership_types.filter(type =>
                String(type.name).toLowerCase().includes(normalized_query)
            );
        },
        get_membership_type_submission_value(value) {
            const normalized_value = String(value || '').trim().toLowerCase();
            if (!normalized_value) return '';

            const selected_type = this.membership_types.find(type =>
                String(type.name).trim().toLowerCase() === normalized_value
            );

            return selected_type ? selected_type.id : value;
        },
        on_membership_type_input() {
            this.show_membership_type_dropdown = true;
        },
        select_membership_type(type) {
            this.membership_type = type.name;
            this.show_membership_type_dropdown = false;
        },
        open_create_membership_modal() {
            this.resetForm();
        },
        submit_membership_form() {
            if (this.editing_membership_id) {
                this.updateMembership();
                return;
            }

            this.createMembership();
        },
        createMembership() {
            if (!this.validateMembershipForm()) {
                return;
            }

            Swal.fire({
                title: 'Submitting...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('description', this.membership_description);
            formData.append('membership_type', this.get_membership_type_submission_value(this.membership_type));
            formData.append('price', this.membership_price);
            formData.append('billing_cycle', this.billing_cycle);

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership/`,
                data: formData,
                processData: false,
                contentType: false,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                },
                success: (response) => {
                    const status = response.status;

                    if (status === "success") {
                        const new_membership = response.data;
                        if (new_membership) {
                            this.memberships.unshift(new_membership);
                            this.total_paid_users[new_membership.id] = this.total_paid_users[new_membership.id] || 0;
                        }
                        Swal.fire({
                            icon: "success",
                            title: "Membership created",
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.resetForm();
                            $('#create_membership').modal('hide');
                        });
                    }
                },
                error: (response) => {
                    Swal.close();
                    const response_data = response.responseJSON;
                    if (response_data) {
                        this.errors = response_data;
                    }
                },
                complete: () => {
                    this.isSubmitting = false;
                },
            });
        },

        fetch_memberships() {
            this.token_exists = get_token();
            this.isLoading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.memberships = response.data.memberships;

                    this.memberships.forEach((membership) => {
                        this.total_paid_user(membership.id);
                    })


                    this.$nextTick(() => {
                        $('.table').DataTable().destroy();  // Destroy previous instance if exists
                        $('.table').DataTable({
                            paging: true,
                            searching: true,
                            ordering: true,
                            info: true,
                            lengthChange: true,
                            pageLength: 10,
                            language: {
                                paginate: {
                                    previous: "Previous",
                                    next: "Next"
                                },
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "No entries available"
                            }
                        });
                    });
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },
        toggleMembership(membership){
            const previous_status = membership.is_active;
            membership.is_active = !membership.is_active;
            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/toggle_membership_status/`,
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                data: JSON.stringify({
                    membership_id: membership.id,
                    is_active: membership.is_active
                }),
                success: (response) => {
                    if(response.status ==='success'){
                        if (this.selected_manage_membership?.id === membership.id) {
                            this.selected_manage_membership = membership;
                        }
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Membership status updated successfully.',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        });
                    }
                },
                error: (response) => {
                    membership.is_active = previous_status;

                    const error_response_data = response.responseJSON || {};
                    const error_message =
                        error_response_data.message ||
                        error_response_data.error ||
                        'Unable to update membership status.';

                    Swal.fire({
                        icon: 'error',
                        title: 'Process failed.',
                        text: error_message,
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                }
            });
        },
        open_manage_membership_modal(membership) {
            this.selected_manage_membership = membership;
            $('#manage_membership_modal').modal('show');
        },
        close_manage_membership_modal() {
            $('#manage_membership_modal').modal('hide');
        },
        open_manage_membership_perks(membership) {
            this.close_manage_membership_modal();
            this.open_manage_perks_modal(membership.id);
        },
        open_manage_membership_users(membership) {
            this.close_manage_membership_modal();
            this.$router.push(`/view_membership_users/${membership.id}`);
        },
        validateMembershipForm() {
            this.errors = {};
            let isValid = true;

            if (!this.membership_type) {
                this.errors.membership_type = "Please select or enter a membership type.";
                isValid = false;
            }

            if (
                this.membership_price === '' ||
                this.membership_price === null ||
                this.membership_price === undefined ||
                Number(this.membership_price) <= 0
            ) {
                this.errors.membership_price = "Please enter a membership price greater than 0.";
                isValid = false;
            }

            if (!this.billing_cycle) {
                this.errors.billing_cycle = "Please select a billing cycle.";
                isValid = false;
            }

            return isValid;
        },


        resetForm() {
            this.editing_membership_id = null;
            this.membership_description = '';
            this.membership_type = '';
            this.membership_price = 0;
            this.billing_cycle = '';
            this.errors = {};
            this.show_membership_type_dropdown = false;
        },

        open_manage_perks_modal(membership_id) {
            this.selected_membership_id = membership_id;
            this.new_perk_name = '';
            this.removed_membership_perks_id = [];
            const selected_membership = this.memberships.find(
                membership => membership.id === membership_id
            );

            if (
                selected_membership &&
                Array.isArray(selected_membership.membership_perks) &&
                selected_membership.membership_perks.length > 0
            ) {
                this.membership_perks = selected_membership.membership_perks.map(item => ({
                    id: item.perk?.id || null,
                    perk: item.perk?.name || ''
                }));
            } else {
                this.membership_perks = [];
            }

            $('#manage_perks_modal').modal('show');
        },

        remove_perk(index) {
            const removed_perk = Reflect.get(this.membership_perks, index);
            if (removed_perk?.id) {
                this.removed_membership_perks_id.push(removed_perk.id);
            }
            this.membership_perks.splice(index, 1);
        },

        add_perk_input() {
            const perk_name = (this.new_perk_name || '').trim();
            if (!perk_name) {
                return;
            }

            this.membership_perks.push({ id: null, perk: perk_name });
            this.new_perk_name = '';
        },

        save_perks_function() {
            const draft_perk_name = (this.new_perk_name || '').trim();
            if (draft_perk_name) {
                this.membership_perks.push({ id: null, perk: draft_perk_name });
                this.new_perk_name = '';
            }

            const payload = {
                membership_perks: this.membership_perks
                    .map(perk => {
                        const perk_name = (perk.perk || '').trim();
                        if (!perk_name) {
                            return null;
                        }

                        return {
                            id: perk.id || null,
                            name: perk_name
                        };
                    })
                    .filter(perk => perk),
                removed_membership_perks_id: this.removed_membership_perks_id,
                membership_id: this.selected_membership_id
            };

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership_perks/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => {
                    const returned_membership_perks =response.data;

                    const membership_index = this.memberships.findIndex(
                        membership => membership.id === this.selected_membership_id
                    );

                    if (membership_index !== -1) {
                        const selected_membership = Reflect.get(this.memberships, membership_index);
                        if (selected_membership) {
                            Reflect.set(selected_membership, 'membership_perks', returned_membership_perks);
                        }
                    }

                    if (this.selected_manage_membership?.id === this.selected_membership_id) {
                        this.selected_manage_membership.membership_perks = returned_membership_perks;
                    }

                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Perks added successfully.',
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                    $('#manage_perks_modal').modal('hide');
                    this.removed_membership_perks_id = [];
                },
                error: (xhr) => {
                    var error_response_data = JSON.parse(xhr.responseText);
                    if (error_response_data.status) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Process failed.',
                            text: error_response_data.message,
                            showConfirmButton: false,
                            timer: 3000,
                            position: 'bottom-end',
                            toast: true
                        });
                    }
                }
            });
        },
        editMembership(membership) {
            this.editing_membership_id = membership.id;
            this.membership_description = membership.description || '';
            this.membership_type = membership.membership_type?.name || membership.custom_type || '';
            this.membership_price = membership.membership_pricing.length > 0 ? membership.membership_pricing[0].price : '';
            this.billing_cycle = membership.billing_cycle?.id || '';
            this.errors = {};
            this.show_membership_type_dropdown = false;
        },

        updateMembership() {
            const payload = {
                membership_id: this.editing_membership_id,
                description: this.membership_description,
                membership_type: this.get_membership_type_submission_value(this.membership_type),
                billing_cycle: this.billing_cycle,
                membership_price: this.membership_price,

            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_membership/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),


                success: (response) => {
                    const updatedData = response.data;

                    this.memberships = this.memberships.map((membership) => {
                        if (membership.id === updatedData.id) {
                            return updatedData;
                        }
                        return membership;
                    });
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Membership updated successfully.',
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                    $('#create_membership').modal('hide');
                },
                error: (xhr) => {
                    this.errors = xhr.responseJSON;
                }
            });
        },

        delete_membership(membership_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {

                    const request_data = JSON.stringify({ membership_id: membership_id });

                    const headers = {
                        'Authorization': `Token ${this.getToken()}`,
                        'Content-Type': 'application/json'
                    };

                    const url = `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_membership/`;

                    $.ajax({
                        type: 'DELETE',
                        url: url,
                        headers: headers,
                        data: request_data,
                        contentType: 'application/json',
                        success: (response) => {
                            if (response.status === "success") {
                                this.memberships = this.memberships.filter(m => m.id !== membership_id);
                                if (this.selected_manage_membership?.id === membership_id) {
                                    this.selected_manage_membership = null;
                                    this.close_manage_membership_modal();
                                }
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Membership deleted',
                                    showConfirmButton: false,
                                    timer: 2000,
                                    position: 'bottom-end',
                                    toast: true
                                });
                            } else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Sorry',
                                    text: 'Could not delete membership.',
                                    confirmButtonText: 'OK',
                                    position: 'bottom-end',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            let errorMessage = 'Could not delete membership.';

                            if (xhr.responseJSON) {
                                if (xhr.responseJSON.message) {
                                    // Handles both string and object messages
                                    if (typeof xhr.responseJSON.message === 'string') {
                                        errorMessage = xhr.responseJSON.message;
                                    } else if (typeof xhr.responseJSON.message === 'object') {
                                        // If message is a validation error dict, get first value
                                        const firstKey = Object.keys(xhr.responseJSON.message)[0];
                                        errorMessage = xhr.responseJSON.message[firstKey][0];
                                    }
                                }
                            }

                            Swal.fire({
                                icon: 'error',
                                title: 'Sorry',
                                text: errorMessage,
                                confirmButtonText: 'OK',
                                position: 'bottom-end',
                                showConfirmButton: false,
                                timer: 3000,
                                toast: true
                            });
                        }


                    });
                }
            });
        },

        total_paid_user(membership_id) {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/total_paid_users_per_membership/?membership_id=${membership_id}`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.total_paid_users[membership_id] = response.total_paid_users;
                },
            });
        }



    },
}
